export default __webpack_public_path__ + "static/media/robot-shadow.cc77e6e9.png";